import { render, staticRenderFns } from "./CompPriceOverview.vue?vue&type=template&id=d7268efa"
import script from "./CompPriceOverview.vue?vue&type=script&lang=js"
export * from "./CompPriceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports